import { Box, Stack } from '@mui/material';
import React, { useState } from 'react';
import Theme from './Theme';
import Navbar from '../components/Navbar';
const Layout = ({ children, path }) => {
  return (
    <>
      <Theme>
        <Box sx={{ bgcolor: '#fff' }}>
          <Stack direction={'row'}>
            <Box
              sx={{
                p: {md:4, xs:1},
                maxWidth: '100%',
                overflow: 'hidden',
                
              }}
              flexGrow={1}
            >
              <Box
                sx={{
                  background: 'linear-gradient(270deg, #F2F4FB 0%, #EFF2FA 25.93%, #E8EDF9 67.2%, #C8D8F1 100%)'
                }}>
                <Navbar />
              </Box>

              {children}
            </Box>
          </Stack>
        </Box>
      </Theme>
    </>
  );
};

export default Layout;
